import { CANDIDATE_PROFILE_CONFIG } from './candidate';
import { COMPANY_PROFILE_CONFIG } from './company';
import { CONTACT_PROFILE_CONFIG } from './contact';
import { HIRING_AUTHORITY_PROFILE_CONFIG } from './hiringAuthority';
import { JOB_ORDER_PROFILE_CONFIG } from './jobOrder';

export const ENTITIES = {
  candidate: CANDIDATE_PROFILE_CONFIG,
  company: COMPANY_PROFILE_CONFIG,
  contact: CONTACT_PROFILE_CONFIG,
  hiringAuthority: HIRING_AUTHORITY_PROFILE_CONFIG,
  jobOrder: JOB_ORDER_PROFILE_CONFIG
};
export { CANDIDATE_DRAWERS, CANDIDATE_PROFILE_CONFIG, CANDIDATE_TAB_IDS } from './candidate';
export {
  COMPANY_DRAWERS,
  COMPANY_PROFILE_CONFIG,
  COMPANY_QUERY_PARAMS,
  COMPANY_TAB_IDS
} from './company';
export {
  ALLOWED_TASKS_BY_CONTACT_ROLE,
  CONTACT_DRAWERS,
  CONTACT_PROFILE_CONFIG,
  CONTACT_QUERY_PARAMS,
  CONTACT_TAB_IDS
} from './contact';
export {
  HIRING_AUTHORITY_DRAWERS,
  HIRING_AUTHORITY_PROFILE_CONFIG,
  HIRING_AUTHORITY_TAB_IDS
} from './hiringAuthority';
export { JOB_ORDER_DRAWERS, JOB_ORDER_PROFILE_CONFIG, JOB_ORDER_TAB_IDS } from './jobOrder';
